import React, { Component, useState, useContext } from "react";
import Button from './library/Buttons';
import Title from './library/Title';
import styled from "styled-components/macro";
import ConfigComponent from "./ConfigComponent";
import { StateContext } from "../state";
import { actions } from "../state/actions";
import { getImageSrcUrl } from '../utils/images';
import { getI18nTranslationOrDefaultValue } from "../utils/i18n";
import { merge } from 'lodash/object';
import classnames from 'classnames';
import { ModalContent } from "./library/Modal";
import { logger } from '../utils/logging';
import { LOGGING } from "../utils/enums";
import { get, mergeWith } from 'lodash/object';
import { cloneDeep } from 'lodash/lang';

const TRANSITION_DURATION = 175;

const PaywallTileContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 360px;
  transition: ${() => `all ${TRANSITION_DURATION}ms ease-out, background-color 500ms linear`};
  height: ${({ isActive }) => (isActive ? "180px" : "70px")};
  overflow: hidden;
  position: relative;
  background: ${({ isDisabled }) => (isDisabled ? "#cecece" : "#fff")};
  // background-color: ${({ isActive }) => isActive ? "#e4f4ff" : "transparent"};
  // background-color: ${({ isActive }) => isActive ? "#ffe50047" : "transparent"};
  opacity: ${({ isDisabled }) => (isDisabled ? "0.4" : "1")};

  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
  
  &:not(.disabled-payment-network):hover {
      box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);
  }
  
  & + & {
    margin-top: 10px;
  }
  
  &.disabled-payment-network {
    // opacity: 0.3;
    cursor: not-allowed;
  }
  
  @media (max-width: 500px) {
    border-radius: 5px;
  }
`;

const Top = styled.div`
  display: flex;
  min-height: 70px;
`;

const FlexCentered = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
`;

const Left = styled(FlexCentered)`
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: 25%;
  
  @media (max-width: 400px) {
    flex-basis: 22%;
  }
  @media (max-width: 360px) {
    flex-basis: 20%;
  }
`;

const Right = styled(FlexCentered)`
  flex-direction: column;
  align-items: flex-start;
  flex-grow: 1;
  text-align: left;
`;

const Logo = styled.img`
  // margin: auto;
  width: 45px;
  
  @media (max-width: 400px) {
    width: 40px;
  }
`;

const TileTitle = styled.h3`
  margin: 0;
  margin-bottom: 0.2em;
  font-weight: normal;
  // text-shadow:
  // 0px 0px 0px #d5d5d5,
  // 1px 1px 0px rgba(0, 0, 0, 0.2);
  // font-style: italic;
  // color: #4b466d;
    opacity: ${({ isDisabled }) => (isDisabled ? "0.8" : "1")};
`;

const Tagline = styled.h4`
  margin: 0;
  font-weight: 500;
  color: #2f79b9; 
  font-style: italic;
  // @media (max-width: 400px) {
  //   font-size: 12px;
  // }
  opacity: ${({ isDisabled }) => (isDisabled ? "0.8" : "1")};
`;

const Description = styled.h4`
  text-align: center;
  font-weight: normal;
  margin: auto;
  line-height: 1.3;
  height: 50px;
  width: 90%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const Bottom = styled.div`
  // flex-direction: column;
  min-height: 80px;
  height: 100px;
  overflow: hidden;
  // padding-bottom: 10px;
`;

const ButtonContainer = styled(FlexCentered)`
  height: 55px;
  width: 100%;
`;

class PaywallTile extends Component {
  constructor(props){
    super(props);

    this.paywallBrickDomNode = React.createRef();
  }

  onClick = () => {
    if(this.props.disabled) {
      this.props.onDisabledClick(this.props.tileConfig);
      return;
    }
    this.props.onClick();
    setTimeout(() => {
      // if the paywall option has expanded from becoming active, make sure it is in view
      if (this.paywallBrickDomNode && this.props.isActive) {
        const {top, bottom} = this.paywallBrickDomNode.getBoundingClientRect();
        const viewportHeight = (window.innerHeight || document.documentElement.clientHeight);

        if (top < 0) {
          this.paywallBrickDomNode.scrollIntoView({ block: 'start', behavior: 'smooth' })
        }
        else if (bottom > viewportHeight) {
          this.paywallBrickDomNode.scrollIntoView({ block: 'end', behavior: 'smooth' })
        }
      }
    }, TRANSITION_DURATION)
  };

  render(){
    const { tileConfig, isActive, network, setSelectedPaymentNetwork, programName, programId } = this.props;

    return(
      <PaywallTileContainer
        id={`paywall-brick-${network.toLowerCase()}`}
        ref={domNode => this.paywallBrickDomNode = domNode}
        isActive={isActive}
        onClick={this.onClick}
        className={classnames({'disabled-payment-network': this.props.disabled})}
        isDisabled={this.props.disabled}
      >
        <Top isActive={isActive}>
          <Left>
            <Logo src={getImageSrcUrl(tileConfig.logo)} />
          </Left>
          <Right>
            <TileTitle isDisabled={this.props.disabled}>{tileConfig.displayName}</TileTitle>
            <Tagline isDisabled={this.props.disabled}><ConfigComponent config={tileConfig.tagline} /></Tagline>
          </Right>
        </Top>
        <Bottom isActive={isActive}>
          <Description>
            {<ConfigComponent config={tileConfig.description}/>}
          </Description>
          <ButtonContainer>
            <Button
              small
              onClick={evt => {
                evt.stopPropagation();
                logger({
                  event: LOGGING.EVENTS.PAYWALL_OPTION_SELECTED,
                  paymentNetwork: network,
                  programId,
                  programName,
                });
                setSelectedPaymentNetwork(network)
              }}
              label={getI18nTranslationOrDefaultValue(`buttons`, tileConfig.btnLabel)}
              // secondary
              // inverted
              // rounded
            />
          </ButtonContainer>
        </Bottom>
      </PaywallTileContainer>
    )
  }
}

const PaywallContainer = styled(FlexCentered)`
  width: 100%;
  flex-direction: column;
  align-items: center;
  // justify-content: ${({numOfTiles}) => numOfTiles > 1 ? 'flex-start' : 'center'};
  justify-content: center;
  height: ${({numOfTiles}) => (130 + (numOfTiles * 70) + ((numOfTiles - 1) * 10)) + 'px'};
  padding: 10px 0;
  
  @media screen and (min-width: 768px) {
    justify-content: ${({numOfTiles}) => numOfTiles > 5 ? 'flex-start' : 'center'};
  }
  
  @media screen and (max-width: 500px) {
    justify-content: flex-start;
  }
`;

let Paywall = () => {
  const [activePaymentNetwork, setActivePaymentNetwork] = useState();
  const [{
    configuration,
    payment,
    accounts,
    selectedPaymentNetwork
  }, dispatch] = useContext(StateContext);

  const config = configuration.paywall;
  const onTileClick = clickedPaymentNetwork => {
    setActivePaymentNetwork(activePaymentNetwork === clickedPaymentNetwork ? null : clickedPaymentNetwork);
    if(!selectedPaymentNetwork){
      logger({
        event: activePaymentNetwork === clickedPaymentNetwork ? LOGGING.EVENTS.PAYWALL_OPTION_COLLAPSED : LOGGING.EVENTS.PAYWALL_OPTION_EXPANDED,
        paymentNetwork: clickedPaymentNetwork,
        programName: configuration.programName,
        programId: payment.programId,
      });
    }
  };

  const paymentNetworkHelpers = {
    filters: {
      excludeNetworksWithoutConfig: network => configuration.paymentNetworks[network],
      excludeNetworksWithoutAccount: network => accounts.reduce((acc, account) => acc || account.paymentNetwork === network, false),
      showHideDisabledNetworksBasedOnConfig: network => accountsMap[network].enabled || config.showDisabledPaymentNetworks,
    },
    sort: {
      showEnabledPaymentNetworksFirst: (networkA, networkB) => {
        // display disabled networks after enabled networks
        if(!accountsMap[networkA].enabled && accountsMap[networkB].enabled) return 1;
        if(accountsMap[networkA].enabled && !accountsMap[networkB].enabled) return -1;
        return 0;
      }
    },
    map: {
      getPaymentNetworkConfigs: network => mergeWith(cloneDeep(configuration), get(configuration, ['paymentNetworks', network], {})),
    },
  };

  const accountsMap = accounts.reduce((acc, account) => ({...acc, [account.paymentNetwork]: account}), {});

  const onDisabledClick = paymentNetworkConfig => {
    const { id: clickedPaymentNetwork } = paymentNetworkConfig;

    if(activePaymentNetwork !== clickedPaymentNetwork) {
      logger({
        event: LOGGING.EVENTS.PAYWALL_DISABLED_NETWORK_CLICKED,
        paymentNetwork: clickedPaymentNetwork,
        programName: configuration.programName,
        programId: payment.programId,
        paymentId: payment.id,
      });
    }

    if(config.showMessageForDisabledPaymentNetworks){
      const disabledPaymentNetworkConfig = get(paymentNetworkConfig, 'paywall.disabledPaymentNetwork', config.disabledPaymentNetwork);

      dispatch(actions.modals.pushModal(<ModalContent
        description={disabledPaymentNetworkConfig.description}
        showFaqLink={false}
        onClose={() => {}}
        dataForVariableSubstitutions={{paymentNetwork: paymentNetworkConfig}}
      />, {className: 'system-notification', title: disabledPaymentNetworkConfig.title}))
    }
  };

  const { filters, sort} = paymentNetworkHelpers;

  const sortedPaymentNetworksToDisplay = payment.availablePaymentNetworks
    .filter(filters.excludeNetworksWithoutConfig)
    .filter(filters.excludeNetworksWithoutAccount)
    .filter(filters.showHideDisabledNetworksBasedOnConfig)
    .sort(sort.showEnabledPaymentNetworksFirst);

  return (
    <>
      <Title>
        <h1><ConfigComponent config={config.title}/></h1>
      </Title>
      <section className="main">
        <p className="description"><ConfigComponent config={config.description} /></p>
        <PaywallContainer numOfTiles={sortedPaymentNetworksToDisplay.length}>
          {sortedPaymentNetworksToDisplay
            .map(paymentNetworkHelpers.map.getPaymentNetworkConfigs)
            .map(paymentNetworkConfig => {
              const { id, paywall: {tile} } = paymentNetworkConfig;

              return (
                <PaywallTile
                  key={id}
                  network={id}
                  tileConfig={merge({}, config.tile, tile)}
                  isActive={activePaymentNetwork === id}
                  onClick={() => onTileClick(id)}
                  setSelectedPaymentNetwork={network => dispatch(actions.selectedPaymentNetwork.setSelectedPaymentNetwork(network))}
                  disabled={!accountsMap[id].enabled}
                  onDisabledClick={() => onDisabledClick(paymentNetworkConfig)}
                  programName={configuration.programName}
                  programId={payment.programId}
                />
              )
            }
          )}
        </PaywallContainer>
      </section>
    </>
  );
};

export default Paywall;
